<template>
	<div class="wrapper">
		<div v-if="loading" class="text-center">
			<b-spinner label="Loading..." style="width: 3rem; height: 3rem;" variant="info"></b-spinner>
		</div>
		<div v-else class="animated fadeIn">
			<b-row>
				<b-col cols="12">
					<b-card header-tag="header">
						<div slot="header">Create New Office</div>
						<b-form @submit.prevent="checkFormValidity()" method="post">
							<b-container fluid>
								<b-row>
									<b-col cols="6">
										<b-card
											header-tag="header"
											footer-tag="footer"
											title="Office Details">

											<b-form-group
												label="Select Project"
												label-for="project-name"
												label-class="required"
												:label-cols="3"
												:horizontal="true"
												invalid-feedback="Please select one."
												:state="$v.form.projectId.$dirty ? !$v.form.projectId.$error : null">
												<model-select id="project-name" :options="projectNameDropDownList" v-model="form.projectId" :isError="$v.form.projectId.$dirty ? $v.form.projectId.$error : false" placeholder="Select Project Name"></model-select>
											</b-form-group>

											<b-form-group
												label="Name"
												label-for="name"
												label-class="required"
												:label-cols="3"
												:horizontal="true">
												<b-form-input v-model="form.name" name="name" id="name" type="text" placeholder="Name" :state="$v.form.name.$dirty ? !$v.form.name.$error : null" aria-describedby="name-live-feedback"></b-form-input>
												<b-form-invalid-feedback id="name-live-feedback">This is a required field and must not be blank.</b-form-invalid-feedback>
											</b-form-group>

											<b-form-group
												label="Title"
												label-for="title"
												label-class="required"
												:label-cols="3"
												:horizontal="true">
												<b-form-input v-model="form.title" name="title" id="title" type="text" placeholder="Title" :state="$v.form.title.$dirty ? !$v.form.title.$error : null" aria-describedby="title-live-feedback"></b-form-input>
												<b-form-invalid-feedback id="title-live-feedback">This is a required field and must not be blank.</b-form-invalid-feedback>
											</b-form-group>

											<b-form-group
												label="Operational Timezone"
												label-for="timezone"
												label-class="required"
												:label-cols="3"
												:horizontal="true"
												invalid-feedback="Please select one."
												:state="$v.form.timezone.$dirty ? !$v.form.timezone.$error : null">
												<model-select id="timezone" :options="timezoneDropDownList" v-model="form.timezone" :isError="$v.form.timezone.$dirty ? $v.form.timezone.$error : false" placeholder="Select Timezone"></model-select>
											</b-form-group>

											<b-form-group
												label="Description"
												label-for="description"
												:label-cols="3"
												:horizontal="true">
												<b-form-textarea v-model="form.description" name="description" id="description" placeholder="Description" rows="4" max-rows="6"></b-form-textarea>
											</b-form-group>

											<b-form-group
												label="Select Office Type"
												label-for="officeType"
												:label-cols="3"
												:horizontal="true">
												<b-form-select v-model="form.officeTypeId"
																			 name="officeType"
																			 id="officeType"
																			 :plain="true"
																			 :options="officeTypeDropDownList"
																			 value="1">
												</b-form-select>
											</b-form-group>

											<b-form-group
												label="Phone"
												label-for="phone"
												label-class="required"
												:label-cols="3"
												:horizontal="true">
												<b-form-input v-model="form.phone" name="phone" id="phone" type="text" placeholder="Phone" :state="$v.form.phone.$dirty ? !$v.form.phone.$error : null" aria-describedby="phone-live-feedback"></b-form-input>
												<b-form-invalid-feedback id="phone-live-feedback">This is a required field and must not be blank.</b-form-invalid-feedback>
											</b-form-group>

											<b-form-group
												label="Email"
												label-for="email"
												label-class="required"
												:label-cols="3"
												:horizontal="true">
												<b-form-input v-model="form.email" name="email" id="email" type="text" placeholder="Email" :state="$v.form.email.$dirty ? !$v.form.email.$error : null" aria-describedby="email-live-feedback"></b-form-input>
												<b-form-invalid-feedback id="email-live-feedback">This is a required field and must be a valid email.</b-form-invalid-feedback>
											</b-form-group>

											<b-form-group
												:horizontal="true"
												:label-cols="3">
												<b-form-checkbox v-model="form.sendEmail"
																				 name="sendEmail"
																				 id="send-email"
																				 switch>
													Send email
												</b-form-checkbox>
											</b-form-group>

											<b-form-group
												label="Select Company"
												label-for="company"
												:label-cols="3"
												:horizontal="true">
												<b-form-select v-model="form.companyId"
																			 name="companyId"
																			 id="company"
																			 :plain="true"
																			 :options="companyDropDownList"
																			 value="New Company">
												</b-form-select>
											</b-form-group>

											<b-form-group
												label="Address"
												label-for="address"
												label-class="required"
												:label-cols="3"
												:horizontal="true">
												<b-form-textarea v-model="form.address" name="address" id="address" placeholder="Address" rows="4" max-rows="6" :state="$v.form.address.$dirty ? !$v.form.address.$error : null" aria-describedby="address-live-feedback"></b-form-textarea>
												<b-form-invalid-feedback id="address-live-feedback">This is a required field and must not be blank.</b-form-invalid-feedback>
											</b-form-group>

											<b-form-group
												label="Select Version"
												label-for="version-id"
												label-class="required"
												:label-cols="3"
												:horizontal="true">
												<b-form-select v-model="form.versionId"
																			 name="versionId"
																			 id="version-id"
																			 :plain="true"
																			 :options="versionTypeDropDownList"
																			 value="Please Select"
																			 :state="$v.form.versionId.$dirty ? !$v.form.versionId.$error : null"
																			 aria-describedby="version-live-feedback">
												</b-form-select>
												<b-form-invalid-feedback id="version-live-feedback">Please select one.</b-form-invalid-feedback>
											</b-form-group>

											<b-form-group
												label="Select Fiscal Year"
												label-for="fiscal-year-id"
												label-class="required"
												:label-cols="3"
												:horizontal="true">
												<b-form-select v-model="form.fiscalYearId"
																			 name="fiscalYearId"
																			 id="fiscal-year-id"
																			 :plain="true"
																			 :options="monthDropDownList"
																			 value="Please Select"
																			 :state="$v.form.fiscalYearId.$dirty ? !$v.form.fiscalYearId.$error : null"
																			 aria-describedby="fiscal-live-feedback">
												</b-form-select>
												<b-form-invalid-feedback id="fiscal-live-feedback">Please select one.</b-form-invalid-feedback>
											</b-form-group>

											<b-form-group
												label="Total Employee Limit"
												label-for="totalEmployeeLimit"
												:label-cols="3"
												:horizontal="true">
												<b-form-input v-model="form.totalEmployeeLimit" name="totalEmployeeLimit" id="totalEmployeeLimit" type="number" placeholder="Total Employee Limit"></b-form-input>
											</b-form-group>

											<b-form-group
												label="Location Tracking User Limit"
												label-for="locationTrackingUserLimit"
												:label-cols="3"
												:horizontal="true">
												<b-form-input v-model="form.locationTrackingUserLimit" name="locationTrackingUserLimit" id="locationTrackingUserLimit" type="number" placeholder="Location Tracking User Limit"></b-form-input>
											</b-form-group>

											<b-form-group
												label="Total Device Limit"
												label-for="totalDeviceLimit"
												:label-cols="3"
												:horizontal="true">
												<b-form-input v-model="form.totalDeviceLimit" name="totalDeviceLimit" id="totalDeviceLimit" type="number" placeholder="Total Device Limit"></b-form-input>
											</b-form-group>
										</b-card>
									</b-col>
									<b-col cols="6">
										<b-card
											header-tag="header"
											footer-tag="footer"
											title="Office Admin Details">
											<b-form-group
												label="Name"
												label-for="employeeName"
												label-class="required"
												:label-cols="3"
												:horizontal="true">
												<b-form-input v-model="form.employeeName" name="employeeName" id="employeeName" type="text" placeholder="Admin Name" :state="$v.form.employeeName.$dirty ? !$v.form.employeeName.$error : null" aria-describedby="employee-name-live-feedback"></b-form-input>
												<b-form-invalid-feedback id="employee-name-live-feedback">This is a required field and must not be blank.</b-form-invalid-feedback>
											</b-form-group>

											<b-form-group
												label="Email"
												label-for="employeeEmail"
												label-class="required"
												:label-cols="3"
												:horizontal="true">
												<b-form-input v-model="form.employeeEmail" name="employeeEmail" id="employeeEmail" type="text" placeholder="Admin Email" :state="$v.form.employeeEmail.$dirty ? !$v.form.employeeEmail.$error : null" aria-describedby="employee-email-live-feedback"></b-form-input>
												<b-form-invalid-feedback id="employee-email-live-feedback">This is a required field and must be a valid email.</b-form-invalid-feedback>
											</b-form-group>

											<b-form-group
												label="Password"
												label-for="employeePassword"
												label-class="required"
												:label-cols="3"
												:horizontal="true">
												<b-form-input v-model="form.employeePassword" name="employeePassword" id="employeePassword" type="password" placeholder="Password" :state="$v.form.employeePassword.$dirty ? !$v.form.employeePassword.$error : null" aria-describedby="employee-password-live-feedback" autocomplete="new-password"></b-form-input>
												<b-form-invalid-feedback id="employee-password-live-feedback">This is a required field and must be at least 6 characters long.</b-form-invalid-feedback>
											</b-form-group>

											<b-form-group
												label="Confirm Password"
												label-for="employeeConfirmPassword"
												label-class="required"
												:label-cols="3"
												:horizontal="true">
												<b-form-input v-model="form.employeeConfirmPassword" name="employeeConfirmPassword" id="employeeConfirmPassword" type="password" placeholder="Confirm Password" :state="$v.form.employeeConfirmPassword.$dirty ? !$v.form.employeeConfirmPassword.$error : null" aria-describedby="employee-confirm-password-live-feedback" autocomplete="new-password"></b-form-input>
												<b-form-invalid-feedback id="employee-confirm-password-live-feedback">This is a required field and must match the password.</b-form-invalid-feedback>
											</b-form-group>

											<b-form-group
												label="Employee Office ID"
												label-for="employeeOfficeId"
												:label-cols="3"
												:horizontal="true">
												<b-form-input v-model="form.employeeOfficeId" name="employeeOfficeId" id="employeeOfficeId" type="text" placeholder="ID" aria-describedby="employee-office-id-live-feedback"></b-form-input>
												<b-form-invalid-feedback id="employee-office-id-live-feedback"></b-form-invalid-feedback>
											</b-form-group>
											<b-form-group
												label="Report Position"
												label-for="reportPosition"
												:label-cols="3"
												:horizontal="true">
												<b-form-input v-model="form.reportPosition" name="reportPosition" id="reportPosition" type="number" placeholder="1" aria-describedby="report-position-live-feedback"></b-form-input>
												<b-form-invalid-feedback id="report-position-live-feedback">Input must be numeric.</b-form-invalid-feedback>
											</b-form-group>

											<b-form-group
												label="RFID"
												label-for="rfid"
												:label-cols="3"
												:horizontal="true">
												<b-form-input v-model="form.rfid" name="rfid" id="rfid" type="text" placeholder="RFID" aria-describedby="rfid-live-feedback"></b-form-input>
												<b-form-invalid-feedback id="rfid-live-feedback"></b-form-invalid-feedback>
											</b-form-group>

											<b-form-group
												label="Primary Display Text"
												label-for="primaryDisplayText"
												label-class="required"
												:label-cols="3"
												:horizontal="true">
												<b-form-input v-model="form.primaryDisplayText" name="primaryDisplayText" id="primaryDisplayText" type="text" placeholder="Primary Display Text" :state="$v.form.primaryDisplayText.$dirty ? !$v.form.primaryDisplayText.$error : null" aria-describedby="primary-display-text-live-feedback"></b-form-input>
												<b-form-invalid-feedback id="primary-display-text-live-feedback">This is a required field and must not be blank.</b-form-invalid-feedback>
											</b-form-group>

											<b-form-group
												label="Secondary Display Text"
												label-for="secondaryDisplayText"
												label-class="required"
												:label-cols="3"
												:horizontal="true">
												<b-form-input v-model="form.secondaryDisplayText" name="secondaryDisplayText" id="secondaryDisplayText" type="text" placeholder="Secondary Display Text" :state="$v.form.secondaryDisplayText.$dirty ? !$v.form.secondaryDisplayText.$error : null" aria-describedby="secondary-display-text-live-feedback"></b-form-input>
												<b-form-invalid-feedback id="secondary-display-text-live-feedback">This is a required field and must not be blank.</b-form-invalid-feedback>
											</b-form-group>
										</b-card>
									</b-col>
								</b-row>

								<b-row>
									<b-col cols="6">
										<b-card
											header-tag="header"
											footer-tag="footer"
											title="Shift Details">
											<b-form-group
												label="Shift Name"
												label-for="shiftName"
												label-class="required"
												:label-cols="3"
												:horizontal="true">
												<b-form-input v-model="form.shiftName" name="shiftName" id="shiftName" type="text" placeholder="Shift Name" :state="$v.form.shiftName.$dirty ? !$v.form.shiftName.$error : null" aria-describedby="shift-name-live-feedback" autocomplete="off"></b-form-input>
												<b-form-invalid-feedback id="shift-name-live-feedback">This is a required field and must not be blank.</b-form-invalid-feedback>
											</b-form-group>

											<b-form-group
												label="Start Time"
												label-for="startTime"
												label-class="required"
												:label-cols="3"
												:horizontal="true">
												<b-form-input v-model="form.startTime" name="startTime" id="startTime" type="time" :state="$v.form.startTime.$dirty ? !$v.form.startTime.$error : null" aria-describedby="start-time-live-feedback" autocomplete="off"></b-form-input>
												<b-form-invalid-feedback id="start-time-live-feedback">This is a required field and must not be blank.</b-form-invalid-feedback>
											</b-form-group>

											<b-form-group
												label="End Time"
												label-for="endTime"
												label-class="required"
												:label-cols="3"
												:horizontal="true">
												<b-form-input v-model="form.endTime" name="endTime" id="endTime" type="time" :state="$v.form.endTime.$dirty ? !$v.form.endTime.$error : null" aria-describedby="end-time-live-feedback" autocomplete="off"></b-form-input>
												<b-form-invalid-feedback id="end-time-live-feedback">This is a required field and must not be blank.</b-form-invalid-feedback>
											</b-form-group>

											<b-form-group
												label="Late Count Start Time"
												label-for="lateCountStartTime"
												label-class="required"
												:label-cols="3"
												:horizontal="true">
												<b-form-input v-model="form.lateCountStartTime" name="lateCountStartTime" id="lateCountStartTime" type="time" :state="$v.form.lateCountStartTime.$dirty ? !$v.form.lateCountStartTime.$error : null" aria-describedby="late-count-start-time-live-feedback" autocomplete="off"></b-form-input>
												<b-form-invalid-feedback id="late-count-start-time-live-feedback">This is a required field and must not be blank.</b-form-invalid-feedback>
											</b-form-group>

											<b-form-group
												label="Early Count End Time"
												label-for="earlyCountEndTime"
												label-class="required"
												:label-cols="3"
												:horizontal="true">
												<b-form-input v-model="form.earlyCountEndTime" name="earlyCountEndTime" id="earlyCountEndTime" type="time" :state="$v.form.earlyCountEndTime.$dirty ? !$v.form.earlyCountEndTime.$error : null" aria-describedby="early-count-end-time-live-feedback" autocomplete="off"></b-form-input>
												<b-form-invalid-feedback id="early-count-end-time-live-feedback">This is a required field and must not be blank.</b-form-invalid-feedback>
											</b-form-group>

											<b-form-group
												:horizontal="true"
												:label-cols="3">
												<b-form-checkbox v-model="form.isMidnightCrossing"
																				 name="isMidnightCrossing"
																				 id="isMidnightCrossing"
																				 switch>
													Shift Crosses Midnight
												</b-form-checkbox>
											</b-form-group>

										</b-card>
									</b-col>
								</b-row>
							</b-container>

							<div class="form-actions">
								<b-button type="submit" variant="primary"><i class="fa fa-dot-circle-o"></i> Add New Office</b-button>
								&nbsp;
								<b-button type="button" variant="danger" @click="resetForm()"><i class="fa fa-ban"></i> Reset</b-button>
							</div>
						</b-form>
					</b-card>
				</b-col>
			</b-row>
		</div>
	</div>

</template>

<script>
import { required, numeric, minValue, requiredIf, email, minLength, sameAs } from 'vuelidate/lib/validators';
import officeService from '@/services/officeService';
import companyService from '@/services/companyService';
import toastService from "@/services/toastService";
import customerService from "@/services/customerService";
import {ModelSelect} from "vue-search-select";
import { TIMEZONE_LIST, DEFAULT_TIMEZONE } from '@/shared/timezoneConstants';

	export default {
		name : "CreateOffice",
		components : {
			ModelSelect
		},
		data : function () {
			return {
				form: {
					projectId : null,
					name: null,
					title: null,
					timezone: DEFAULT_TIMEZONE,
					description: null,
					officeTypeId: 1,
					phone: null,
					email: null,
					sendEmail : false,
					companyId: null,
					address: null,
					versionId: null,
					fiscalYearId: null,
					shiftName: null,
					startTime: null,
					endTime: null,
					lateCountStartTime: null,
					earlyCountEndTime: null,
					isMidnightCrossing: false,
					employeeEmail: null,
					employeeName: null,
					employeePassword: null,
					employeeConfirmPassword: null,
					reportPosition: null,
					rfid: null,
					primaryDisplayText: null,
					secondaryDisplayText: null,
					employeeOfficeId: null,
					totalEmployeeLimit: 25,
					locationTrackingUserLimit: 0,
					totalDeviceLimit: 2
				},
				companyList: [],
				companyDropDownList: [ {text: 'New Company', value: null} ],
				officeTypeDropDownList: [
					{text: "Corporate", value: 1},
					{text: "Factory", value : 2}
				],
				versionTypeDropDownList : [
					{text: 'Please Select', value: null},
					{text: "Essential", value: 7},
					{text: "Standard", value : 8},
					{text: "Premium", value: 9},
					{text: "Free for life", value: 10},
					{text: "Free with Device", value: 6},
					{text: "Basic", value: 1},
					{text: "Intermediate", value : 2},
					{text: "Advanced", value: 3}
				],
				monthDropDownList : [
					{text: 'Please Select', value: null},
					{text: "January", value: 1},
					{text: "February", value : 2},
					{text: "March", value: 3},
					{text: "April", value: 4},
					{text: "May", value: 5},
					{text: "June", value: 6},
					{text: "July", value: 7},
					{text: "August", value: 8},
					{text: "September", value: 9},
					{text: "October", value: 10},
					{text: "November", value: 11},
					{text: "December", value: 12}
				],
				timezoneDropDownList: TIMEZONE_LIST,
				projectNames : [],
				projectNameDropDownList : [],
				loading : false
			}
		},
		methods: {
			checkFormValidity: function(){
				let formHasErrors = false;

				this.$v.form.$touch();
				if (this.$v.form.$anyError) {
					formHasErrors = true;
				}

				if(formHasErrors) return;
				else this.createNewOffice();
			},
			resetForm: function(){
				this.form.projectId = null;
				this.form.name = null;
				this.form.title = null;
				this.form.description = null;
				this.form.officeTypeId = 1;
				this.form.phone = null;
				this.form.email = null;
				this.form.sendEmail = false;
				this.form.companyId = null;
				this.form.address = null;
				this.form.versionId = null;
				this.form.fiscalYearId = null;
				this.form.shiftName = null;
				this.form.startTime = null;
				this.form.endTime = null;
				this.form.lateCountStartTime = null;
				this.form.earlyCountEndTime = null;
				this.form.isMidnightCrossing = false;
				this.form.employeeEmail = null;
				this.form.employeeName = null;
				this.form.employeePassword = null;
				this.form.employeeConfirmPassword = null;
				this.form.reportPosition = null;
				this.form.rfid = null;
				this.form.primaryDisplayText = null;
				this.form.secondaryDisplayText = null;
				this.form.employeeOfficeId = null;
				this.form.totalEmployeeLimit = 25;
				this.form.locationTrackingUserLimit = 0;
				this.form.totalDeviceLimit = 2;
			},
			createNewOffice: function () {
				const formData = {
					projectId: this.form.projectId,
					officeName: this.form.name,
					clientPanelTitle: this.form.title,
					officeType: this.form.officeTypeId,
					description: this.form.description,
					phone: this.form.phone,
					email: this.form.email,
					sendEmail : this.form.sendEmail,
					companyId: this.form.companyId,
					location: this.form.address,
					versionId: this.form.versionId,
					fiscalYearId: this.form.fiscalYearId,
					shiftName: this.form.shiftName,
					startTime: this.convertTo12hTime(this.form.startTime),
					endTime: this.convertTo12hTime(this.form.endTime),
					lateCountStartTime: this.convertTo12hTime(this.form.lateCountStartTime),
					earlyCountEndTime: this.convertTo12hTime(this.form.earlyCountEndTime),
					isMidnightCrossing: this.form.isMidnightCrossing,
					employeeEmail: this.form.employeeEmail,
					employeeName: this.form.employeeName,
					employeePassword: this.form.employeePassword,
					reportPosition: this.form.reportPosition,
					rfid: this.form.rfid,
					primaryDisplayText: this.form.primaryDisplayText,
					secondaryDisplayText: this.form.secondaryDisplayText,
					employeeOfficeId: this.form.employeeOfficeId,
					totalEmployeeLimit: this.form.totalEmployeeLimit,
					locationTrackingUserLimit: this.form.locationTrackingUserLimit,
					totalDeviceLimit: this.form.totalDeviceLimit,
					timezone: this.form.timezone
				};
				// console.log(formData);
				officeService.createNewOffice(formData, (data) => {
					this.$nextTick(() => { this.$v.$reset() });
					this.resetForm();
					toastService.showSuccessToast("Office Successfully created");
				}, (error) => {
					toastService.showErrorToast("Could not create new office " + error);
				});
			},
			getCompanyList: function () {
				companyService.getAllCompanies((data) =>{
					this.companyList = data;
					this.createCompanyDropDownList();
				}, (error) =>{
					toastService.showErrorToast("Could not fetch company list " + error);
				});
			},
			createCompanyDropDownList: function () {
				this.companyList.forEach((item) => {
					let company = new Object();
					company.text = item.name;
					company.value = item.id;
					this.companyDropDownList.push(company);
				});
			},
			getProjectNames : function () {
				customerService.getProjectNames((data) => {
					this.projectNames = data;
					this.createProjectNameDropDownList();
					this.loading = false;
				}, (error) => {
					this.loading = false;
					toastService.showErrorToast("Could not fetch project names" + error);
				});
			},
			createProjectNameDropDownList : function () {
				this.projectNames.forEach((value) => {
					let project = new Object();
					project.text = value.name;
					project.value = value.id;
					this.projectNameDropDownList.push(project);
				});
			},
			convertTo12hTime : function (time) {
				let hour = parseInt(time.split(":")[0]);
				let min = parseInt(time.split(":")[1]);
				let half = hour < 12 ? " AM" : " PM";
				hour = hour % 12;

				return hour.toString().padStart(2, "0") + ":" + min.toString().padStart(2, "0") + half;
			}
		},
		validations: {
			form: {
				projectId : {
					required,
					numeric
				},
				name: {
					required
				},
				title: {
					required
				},
				timezone: {
					required
				},
				phone: {
					required
				},
				email: {
					required,
					validEmail: email
				},
				address: {
					required
				},
				versionId: {
					required,
					minValue: minValue(1)
				},
				fiscalYearId: {
					required,
					minValue: minValue(1)
				},
				shiftName: {
					required
				},
				startTime: {
					required
				},
				endTime: {
					required
				},
				lateCountStartTime: {
					required
				},
				earlyCountEndTime: {
					required
				},
				employeeEmail: {
					required,
					validEmail: email
				},
				employeeName: {
					required
				},
				employeePassword: {
					required,
					minLength: minLength(6)
				},
				employeeConfirmPassword: {
					required,
					sameAsPassword: sameAs('employeePassword')
				},
				primaryDisplayText: {
					required
				},
				secondaryDisplayText: {
					required
				}
			}
		},
		created() {
			this.loading = true;
			this.getProjectNames();
			this.getCompanyList();
		}

	}
</script>

<style src="vue-search-select/dist/VueSearchSelect.css"></style>
